import { render, staticRenderFns } from "./GradeSelectButton.vue?vue&type=template&id=0dd59d37&scoped=true&lang=pug&"
import script from "./GradeSelectButton.vue?vue&type=script&lang=ts&"
export * from "./GradeSelectButton.vue?vue&type=script&lang=ts&"
import style0 from "./GradeSelectButton.vue?vue&type=style&index=0&id=0dd59d37&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd59d37",
  null
  
)

export default component.exports